import { addYears } from 'date-fns'

export const getLoteImunobiologicoMaxDate = (minDate: Date): Date => addYears(minDate, 10)
